import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const OnboardingForm = ({ onSubmit, loading, invitedRole }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    city: '',
    state: '',
    role: invitedRole || 'provider'
  });

  const [errors, setErrors] = useState({});

  const roleOptions = [
    { value: 'provider', label: 'Provider (Surgeon)' },
    { value: 'practice_marketer', label: 'Practice Marketer' }
  ];

  const stateOptions = [
    { value: '', label: 'Select State' },
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ];

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    const newErrors = {};
    
    if (!formData?.fullName?.trim()) {
      newErrors.fullName = 'Full name is required';
    }
    
    if (!formData?.practiceName?.trim()) {
      newErrors.practiceName = 'Practice name is required';
    }
    
    if (!formData?.city?.trim()) {
      newErrors.city = 'City is required';
    }
    
    if (!formData?.state) {
      newErrors.state = 'State is required';
    }
    
    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
      return;
    }
    
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
      <Input
        type="text"
        name="fullName"
        label="Full Name"
        placeholder="Dr. Sarah Mitchell"
        value={formData?.fullName}
        onChange={handleChange}
        error={errors?.fullName}
        required
      />
      <Input
        type="text"
        name="practiceName"
        label="Practice Name"
        placeholder="Advanced Surgical Associates"
        value={formData?.practiceName}
        onChange={handleChange}
        error={errors?.practiceName}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          type="text"
          name="city"
          label="City"
          placeholder="San Francisco"
          value={formData?.city}
          onChange={handleChange}
          error={errors?.city}
          required
        />

        <Select
          label="State"
          options={stateOptions}
          value={formData?.state}
          onChange={(value) => handleSelectChange('state', value)}
          error={errors?.state}
          required
          searchable
        />
      </div>
      <Select
        label="Role"
        description="Select your role in the practice"
        options={roleOptions}
        value={formData?.role}
        onChange={(value) => handleSelectChange('role', value)}
        disabled={!!invitedRole}
      />
      <div className="pt-4 md:pt-6">
        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={loading}
          disabled={loading}
          iconName="ArrowRight"
          iconPosition="right"
        >
          {loading ? 'Completing Setup...' : 'Complete Setup'}
        </Button>
      </div>
    </form>
  );
};

export default OnboardingForm;